import { routes } from "@/routes/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { CATEGORY_NAME, DESCRIPTION } from "./consts";
import { useNavigate } from "react-router-dom";
import { schema, formValues } from "./validations";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import { useQueryClient } from "@tanstack/react-query";
import { useAddProjectCategoryMutation } from "@/services";
import { toast } from "@/components";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useAdd = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [CATEGORY_NAME]: "",
      [DESCRIPTION]: "",
    },
  });

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  const requiredFields = getRequiredFields(schema);

  const breadcrumbData = [
    {
      link: `/${routes.admin}/${routes.masterData}/${routes.category}`,
      name: `Category`,
    },
    {
      link: "",
      name: "Add",
    },
  ];

  const onBackClick = () => {
    navigate(`/${routes.admin}/${routes.masterData}/${routes.category}`);
  };

  const { mutate: addInfo, isPending: isAddPending } =
    useAddProjectCategoryMutation({
      onError: (error?: any) => {
        toast({
          message:
            typeof error?.response?.data?.message === "string"
              ? error?.response?.data?.message
              : "Something went wrong",
          type: "error",
        });
        return error?.response?.data?.message;
      },
      onSuccess: () => {
        toast({ message: "Category Added Successfully" });
        queryClient.invalidateQueries({
          queryKey: ["project-categories"],
        });
        onBackClick();
      },
    });

  const onSubmit = (data: formValues) => {
    let _data = removeEmptyFields(data);
    _data = setEmptyFieldsToNull(_data);

    addInfo({ tenantId: loggedInUserData?.tenantId, data: { ..._data, 'catCode': `CAT${Math.random() * 3}` } });
  };

  return {
    breadcrumbData,
    onBackClick,
    form,
    onSubmit,
    isAddPending,
    requiredFields,
    onCancel: onBackClick,
  };
};

export default useAdd;
